/* global __webpack_nonce__ */

function readCspNonce() {
  const nonceTag = document.querySelector('meta[name="csp-nonce"]');
  return nonceTag && nonceTag.content ? nonceTag.content : '';
}

const nonce = readCspNonce();
window.__CD_CSP_NONCE__ = nonce;

if (nonce) {
  const originalCreateElement = document.createElement;
  document.createElement = function (tagName) {
    const createdElement = originalCreateElement.call(document, tagName);
    if (typeof tagName === 'string' && tagName.toLowerCase() === 'style') {
      createdElement.setAttribute('nonce', nonce);
    }

    return createdElement;
  };
}

if (nonce) {
  /* jshint -W020, -W106 */
  __webpack_nonce__ = nonce;
  /* jshint +W020, +W106 */
}
